module.exports = __webpack_public_path__ + "img/clients.80dced60.svg";